/**
 *
 * @version 2026-09-03
 * @author Patrik Harag
 */

/**
 *
 * @param e {*}
 * @return {string}
 */
export function format(e) {
    if (e === null || e === undefined) {
        return String(e);
    }
    if (typeof e === 'string') {
        return e;
    }
    // Fetch Response – statusText is often empty with HTTP/2
    if (typeof e.status === 'number' && typeof e.ok === 'boolean') {
        let statusText = (typeof e.statusText === 'string') ? e.statusText.trim() : '';
        if (statusText !== '') {
            return e.status + ' ' + statusText;
        }
        return String(e.status);
    }
    if (e instanceof Error) {
        return String(e);
    }
    return String(e);
}
